import styled from 'styled-components';

import BookButton from 'components/Button/BookButton';
import Image from 'components/Image';
import RichText from 'components/RichText';

import { PRICING_HASH_ID } from 'utils/constants';

import { BackgroundTexture } from 'styles/global';
import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import FONTS from 'styles/fonts';
import { Grid, columns } from 'styles/grid';
import TYPO, { P1, P2, rem, weight } from 'styles/typography';

const Section = styled(Grid)`
  padding: 84px var(--gutter-side) 164px;
  background-color: ${COLORS.lilac.opacity(0.45)};
  color: ${COLORS.purpleDark};
  ${BackgroundTexture}

  ${BREAKPOINTS.medium`
    padding: 140px var(--gutter-side) 152px;
  `}
`;

const Content = styled.div`
  ${columns(null, 12)}

  ${BREAKPOINTS.small`
    ${columns(2, 10)}
  `}

  ${BREAKPOINTS.large`
    ${columns(2, 4)}
  `}
`;

const Title = styled(RichText)`
  margin-bottom: 24px;
  * {
    ${TYPO.h4}
    font-weight: ${weight.semibold};
  }
`;

const Description = styled(P1)`
  margin-bottom: 40px;
  max-width: 545px;
`;

const Item = styled.div`
  padding: 11px 0 13px;
  border-bottom: 1px solid ${COLORS.purple.opacity(0.2)};

  &:first-of-type {
    border-top: 1px solid ${COLORS.purple.opacity(0.2)};
  }

  ${BREAKPOINTS.large`
    padding: 14px 0 16px;
  `}
`;

const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;

  ${BREAKPOINTS.large`
    margin-bottom: 3px;
  `}
`;

const PriceTitle = styled.h3`
  font-size: ${rem(30)};
  line-height: ${rem(36)};
`;

const Price = styled.h3`
  margin: 0;
  font: ${weight.medium} ${rem(30)} / ${rem(40)} ${FONTS.poppins};
  letter-spacing: ${rem(-1)};
`;

const OpeningTimes = styled(P2)`
  margin: 0;
  opacity: 1;
  white-space: pre-wrap;
`;

const Groups = styled(P2)`
  margin: 0;
  opacity: 0.5;
`;

const PricingImage = styled.div`
  ${columns(null, 12)}
  position: relative;
  margin: 30px auto;
  max-width: 591px;
  width: 100%;
  height: 227px;

  ${BREAKPOINTS.small`
    margin: 50px auto;
    height: 400px;
  `}

  ${BREAKPOINTS.large`
    ${columns(7, 5)}
    margin: 30px auto;
  `}
`;

const BookBtn = styled(BookButton)`
  position: absolute;
  right: 10px;
  bottom: -90px;

  ${BREAKPOINTS.large`
    right: auto;
    left: -60px;
    bottom: -100px;
  `}
`;

const Pricing = ({ title, description, prices, image }) => {
  return (
    <Section id={PRICING_HASH_ID}>
      <Content>
        <Title html={title?.html} />
        <Description indent>{description}</Description>
        <div>
          {prices.map((info) => (
            <Item key={info.title}>
              <ItemRow>
                <PriceTitle>{info.title}</PriceTitle>
                <Price>{info.price}</Price>
              </ItemRow>
              <ItemRow>
                <OpeningTimes>{info.openingTimes}</OpeningTimes>
                <Groups>{info.groups}</Groups>
              </ItemRow>
            </Item>
          ))}
        </div>
      </Content>
      {image?.url && (
        <PricingImage>
          <Image image={image} />
          <BookBtn size="medium" />
        </PricingImage>
      )}
    </Section>
  );
};

export default Pricing;
